module.exports = __webpack_public_path__ + "static/media/result_clear_image.ceeb1098.png";